import Config from '../../Config'
import store from '../../store'

export const userService = {
  login,
  verificaCPF,
  storeUser,
  pickVaga,
  trocaSenha,
  ativarEmail
}

async function login() {

  const _user = store.getters.getUser;

  const _params = {
    'cpf': _user.cpf,
    'senha': _user.senha,
    'tk_google': _user.token_google
  }


  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(_params)
  };

  return fetch(`${Config.baseUrl}/CandidatoAuth/${store.getters.getApiKey}`, requestOptions)
    .then(response => {
      if (response.status === 200) {
        return response.json();
      } else {
        const obj = {
          error: response.text()
        }
        return obj;
      }
    }).catch(
      error => {
        return { 'error': error }
      }
    );
}

async function verificaCPF(cpf) {
  const requestOptions = {
    method: 'GET'
  };

  return fetch(`${Config.baseUrl}/CandidatoConsulta/${store.getters.getApiKey}/${cpf}`, requestOptions)
    .then(response => {
      return response.json();
    })
    .catch(
      error => {
        return { 'error': error }
      }
    );
}

async function storeUser() {

  const _user = { candidato: { usuario: store.getters.getUser } }

  let changeMethod = 'PUT';

  if (store.getters.getGoogleObj.googleId && !_user.candidato.usuario.token_google) {
    _user.candidato.usuario.token_google = store.getters.getGoogleObj.googleId
  }

  if (!_user.candidato.usuario.id > 0) {
    changeMethod = 'POST';
  }

  const requestOptions = {
    //! method: 'POST',
    method: changeMethod,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': Config.authHeader()
    },
    body: JSON.stringify(_user)
  };

  return fetch(`${Config.baseUrl}/Candidato/salvar/${store.getters.getApiKey}`, requestOptions)
}

async function pickVaga(vaga_id) {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': Config.authHeader()
    }
  };
  return fetch(`${Config.baseUrl}/Candidato/vaga/${store.getters.getApiKey}/${vaga_id}`, requestOptions)
    .then(response => {
      return response;
    })
    .catch(
      error => {
        return { 'error': error }
      }
    );
}

async function trocaSenha(_senha) {
  const _user = { senha: _senha };
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': Config.authHeader()
    },
    body: JSON.stringify(_user)
  };
  return fetch(`${Config.baseUrl}/Candidato/trocarsenha/${store.getters.getApiKey}`, requestOptions)
    .then(response => {
      return response;
    })
    .catch(
      error => {
        return { 'error': error }
      }
    );
}


async function ativarEmail() {

  const requestOptions = {
    method: 'POST',    
    headers: {
      'Content-Type': 'application/json',
      'Authorization': Config.authHeader()
    }
  };

  return fetch(`${Config.baseUrl}/Candidato/validemail/${store.getters.getApiKey}`, requestOptions)
}


